// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_container__ihOOK {
  padding: 2rem; }

.styles_header__TKsvz {
  margin-bottom: 2rem; }

.styles_subscriptionsCard__ntItg {
  min-height: 60rem; }

.styles_tabContainer__lqu1F {
  padding: 2rem 0rem;
  max-height: 55rem;
  overflow-y: auto; }
`, "",{"version":3,"sources":["webpack://./src/modules/admin/components/screens/AdminSubscriptionsScreen/styles.module.scss"],"names":[],"mappings":"AAAA;EACI,aAAa,EAAA;;AAGjB;EACI,mBAAmB,EAAA;;AAGvB;EACI,iBAAiB,EAAA;;AAGrB;EACI,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB,EAAA","sourcesContent":[".container {\n    padding: 2rem;\n}\n\n.header {\n    margin-bottom: 2rem;\n}\n\n.subscriptionsCard {\n    min-height: 60rem;\n}\n\n.tabContainer {\n    padding: 2rem 0rem;\n    max-height: 55rem;\n    overflow-y: auto;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `styles_container__ihOOK`,
	"header": `styles_header__TKsvz`,
	"subscriptionsCard": `styles_subscriptionsCard__ntItg`,
	"tabContainer": `styles_tabContainer__lqu1F`
};
export default ___CSS_LOADER_EXPORT___;
